import { formatCalendarDay } from '@/lib/format/date'
import { closeCivilDay } from '@/lib/listing/days-live'

/**
 * "Closed Sep 2026" for the listing price pill. CloseDate is an MLS calendar
 * day stored as midnight UTC; zoning that instant into Pacific moved a sale
 * on the 1st into the previous month. Take the civil day verbatim (the same
 * reading the sold section uses) and format it without a clock.
 */
export function closedPillLabel(closeDate: string | null | undefined): string | null {
  const day = closeCivilDay(closeDate)
  if (!day) return null
  const label = formatCalendarDay(day, { month: 'short', day: undefined, year: 'numeric' })
  return label ? `Closed ${label}` : null
}
